export const AVAIL_BY_DATE = 'availabilityByDateToggle';
export const AVAIL_BY_SOURCE = 'availabilityBySourceToggle';
